export function isLocalStorageAvailable(): boolean {
  try {
    localStorage.setItem('local-storage-helper-check', '1');
    localStorage.removeItem('local-storage-helper-check');
    return true;
  } catch (e) {
    return false;
  }
}

export function getLocalStorageItem(key: string): string|null {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    // We return null as a case where local storage is not available
    return null;
  }
}

export function setLocalStorageItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    // We don't handle a case where local storage is not available
  }
}

export function removeLocalStorageItem(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // We don't handle a case where local storage is not available
  }
}
